// components/TruncatedText.js
import React, { useState } from 'react';

const TruncatedText = ({ text, maxLength = 3 }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded(!expanded);

  return (
    <div style={{ width: 250, whiteSpace: 'pre-wrap' }}>
      <div
        style={{
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitLineClamp: expanded ? 'none' : maxLength,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {text}
      </div>
      {text?.length > 100 && (
        <span
          onClick={toggleExpand}
          style={{ color: 'blue', cursor: 'pointer', fontSize: 12 }}
        >
          {expanded ? 'Less' : 'More'}
        </span>
      )}
    </div>
  );
};

export default TruncatedText;
